import { DISPOSITION_MAP_KEYS_TRANSLATIONS } from "@/types/api/maps";
import { DispositionKeys } from "@/types/api/derived";

const mapDispositions = (
  dispositions: DispositionKeys[] | undefined,
): string[] =>
  (dispositions || []).map((k) => DISPOSITION_MAP_KEYS_TRANSLATIONS[k]);

export default mapDispositions;
